import { useCallback, useEffect } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, useTheme } from "@mui/material";

import Toast from "@covertree/utils/Toast";
import { featureFlags } from "@utils/featureFlags";

import { useLazySearchResidentsQuery } from "@redux/residents/residentsApi";
import { useMappedSearchResults } from "@redux/residents/hooks/useMappedSearchResults";
import { RESIDENTS_SEARCH_TABLE_COLUMNS } from "@redux/residents/utils";

import { SearchBox } from "@covertree/ui";

export default function Search() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [searchResidents, { data, isLoading, isError }] =
    useLazySearchResidentsQuery();

  const rows = useMappedSearchResults(data?.items);

  const search = useCallback(
    (queryString: string) => {
      searchResidents({ query: queryString });
    },
    [searchResidents]
  );

  useEffect(() => {
    if (isError) {
      Toast.showError(
        "Unable to search for residents. Please try again or contact us."
      );
    }
  }, [isError]);

  if (!featureFlags.searchResidents.isEnabled()) {
    return <></>;
  }

  return (
    <Box
      sx={{
        ...(isMobile
          ? {
              position: "absolute",
              right: theme.spacing(2),
              top: theme.spacing(1.5),
            }
          : {}),
      }}>
      <SearchBox
        title="Search residents"
        resultsTitle="Residents"
        placeholder="Search by resident id, name, address, phone number or email"
        loading={isLoading}
        rows={rows}
        columns={RESIDENTS_SEARCH_TABLE_COLUMNS}
        searchFn={search}
        type="DEFAULT_CONTENT"
      />
    </Box>
  );
}
